export default __webpack_public_path__ + "static/media/project-review.7bd2204c.jpg";